/**
 * Typed GraphQL operations for looking up pop.in users.
 *
 * Used by the Members page: a brand owner types a username, we fetch the public
 * profile so they can verify it's the right person before granting brand access.
 */

import { graphql, gqlRequest } from '@/lib/graphql';

const UserByUsernameQuery = graphql(`
  query UserByUsername($username: String!) {
    user(by: $username) {
      id
      public {
        displayName
        username
        photoURL
        bio
        createdAt
      }
    }
  }
`);

/** The public profile shown in the "is this the right person?" preview. */
export interface UserProfile {
  id: string;
  displayName: string;
  username: string;
  photoURL: string;
  bio: string;
  /** Sign-up time, epoch milliseconds. */
  createdAt: number;
}

/** Look up a user's public profile by username. Null when no user matches. */
export async function lookupUserByUsername(username: string): Promise<UserProfile | null> {
  const data = await gqlRequest(UserByUsernameQuery, { username });
  const user = data.user;
  if (!user) return null;
  return {
    id: user.id,
    displayName: user.public.displayName || user.public.username,
    username: user.public.username,
    photoURL: user.public.photoURL,
    bio: user.public.bio,
    createdAt: user.public.createdAt,
  };
}
